module.exports = __webpack_public_path__ + "static/media/dodo.75239e7f.jpg";